import crud from './helpers/crud';
import { servletGetAll } from './helpers';

const ACCOUNT_DATA_GAME_KEYS =
  [ 'recruits', 'accountRecruits', 'accountFollowedTeams', 'accountUserEventData', 'accountEventData' ];

export default class GameDAO extends crud {
  constructor(urls) {
    super(urls.GAMES_URL);
    this.GAMES_URL = urls.GAMES_URL;
  }

  save(game, ...args) {
    // omit account level data associated with the game before sending
    return super.save(_.omit(game, ACCOUNT_DATA_GAME_KEYS), ...args);
  }

  fetchForVenueGrid(params) {
    const allGamesParams = _.omit(params, 'followedBy', 'start', 'count');

    return Promise.all([
      servletGetAll(this.GAMES_URL, params),
      servletGetAll(this.GAMES_URL, allGamesParams)
    ]).then(
      ([ followedGames, allGames ]) => {
        const followedGamesById = _.indexBy(followedGames, 'id');

        return allGames.map(
          game => ({
            ...game,
            isScheduled: Boolean(followedGamesById[ game.id ])
          })
        );
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/GameDAO.js